import { Fragment, useState } from "react";
import { PointsCount } from "./PointsCount";
import { PowerupEllipse } from "./PowerupEllipse";
import { PowerupsDropdown } from "./PowerupsDropdown";
import { CustomModal } from "../../shared/components";
import { renderToast } from "./Toast";
import useSound from "use-sound";
import { addPrefix, analytics } from "@services/analytics";
import { useRouter } from "next/router";
import { zeroPad } from "@modules/gameplay/components/base/CollectionHeader";

export const CollectionsHeader = ({
    student,
    baseAnalyticsEvent,
    scoreType = "points",
    set,
}) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const [playPowerupMenuSound] = useSound(
        "/assets/sounds/Open Menu_bubble-pop-swoosh-SBA-300463464.mp3",
    );
    const [playPowerupSelectSound] = useSound(
        "/assets/sounds/Select Sound_minimal-beep-alert-2-SBA-300463242.mp3",
    );

    const { query } = useRouter();
    const { collection_id, set_id } = query;
    const powerupEvent = {
        referrer: "collection_list",
        question_no: null,
        total_questions: null,
        ...baseAnalyticsEvent,
    };
    const powerupEllipseClick = async ({ method = "arrow_button" }) => {
        await analytics.track(
            !showDropdown ? "powerups_menu_opened" : "powerups_menu_closed",
            {
                ...powerupEvent,
                method,
            },
        );
        playPowerupMenuSound();
        setShowDropdown(!showDropdown);
    };

    const handlePowerupClick = async (powerup: any) => {
        await analytics.track("powerups_application_failed", powerupEvent);
        renderToast({
            message: `${powerup.type.replace(
                "_",
                " ",
            )} powerup not applicable here`,
        });
    };

    return (
        <Fragment>
            <div className="fixed top-0 z-10 flex flex-row items-start justify-between px-4 py-3 bg-white w-i">
                <PowerupEllipse
                    onClick={powerupEllipseClick}
                    showDropdown={showDropdown}
                    powerupCount={student.powerups.reduce(function (acc, obj) {
                        return acc + obj.count;
                    }, 0)}
                />
                <div className="relative w-16 h-16 ml-8">
                    <img
                        src={"/assets/images/trophy-round-bottom-full.png"}
                        alt="trophy"
                        className="object-contain w-full h-full"
                    />
                    <span className="absolute top-0 left-0 flex flex-row items-start justify-center w-16 h-16 pt-2 text-base font-extrabold">
                        {student.trophies}
                    </span>
                </div>
                <div className="mt-2 ">
                    <PointsCount
                        points={zeroPad(
                            set.type == "practise_learn_practise"
                                ? student.stars
                                : student.points,
                            3,
                        )}
                        scoreType={scoreType}
                    />
                </div>
            </div>
            {showDropdown && (
                <CustomModal callback={powerupEllipseClick} top={"52px"}>
                    <PowerupsDropdown
                        powerups={student.powerups}
                        onPowerupClick={async (props: any) => {
                            const { type } = props;
                            await analytics.track("powerup_clicked", {
                                referrer: "collection_list",
                                question_no: null,
                                total_questions: null,
                                ...baseAnalyticsEvent,
                                powerup_type: type,
                            });

                            playPowerupSelectSound();
                            handlePowerupClick(props);
                            setShowDropdown(false);
                        }}
                        set={set}
                    />
                </CustomModal>
            )}
        </Fragment>
    );
};
